// Polish

export default {

  component: {
    jobAdList: {
      title: 'Wolne stanowiska pracy',
      jobs: 'prace',
      noJobAds: 'W tej chwili nie ma żadnych wolnych stanowisk.',
    },

    jobAdCard: {
      openUntil: date => `Aktualne do ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Dziękujemy.',
      readyInfo: 'Twoje podanie zostało przyjęte. Rekruter wkrótce skontaktuje się z Tobą.',
      luck: 'Powodzenia!',
    },

    jobAdSeeYou: {
      title: 'Dziękujemy.',
      description: 'Twoja aplikacja została zapisana i wysłaliśmy Ci link, który umożliwia dokończenie aplikacji.',
    },

    unpublished: {
      title: 'Nieopublikowane',
      info: 'Ogłoszenie o pracę nie zostało jeszcze opublikowane.',
    },
  },

  page: {},

}
